import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, mergeProps as _mergeProps, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from 'assets/images/promo/askg.svg'
import _imports_1 from 'assets/images/promo/casino-on-line-com.svg'
import _imports_2 from 'assets/images/promo/10min.svg'
import _imports_3 from 'assets/images/promo/casino.svg'
import _imports_4 from 'assets/images/promo/money.png'
import _imports_5 from 'assets/images/promo/box.png'
import _imports_6 from 'assets/images/promo/smille.png'
import _imports_7 from 'assets/images/promo/yggdrasil.svg'
import _imports_8 from 'assets/images/promo/1x2gaming.svg'
import _imports_9 from 'assets/images/promo/2by2.svg'
import _imports_10 from 'assets/images/promo/ainsworth.svg'
import _imports_11 from 'assets/images/promo/authentic.svg'
import _imports_12 from 'assets/images/promo/amatic.svg'
import _imports_13 from 'assets/images/promo/fantasma.svg'
import _imports_14 from 'assets/images/promo/betsoft.svg'
import _imports_15 from 'assets/images/promo/irondogstudio.svg'
import _imports_16 from 'assets/images/promo/belatra.svg'
import _imports_17 from 'assets/images/promo/bigtimegaming.svg'
import _imports_18 from 'assets/images/promo/betgamestv.svg'
import _imports_19 from 'assets/images/promo/blablabla.svg'
import _imports_20 from 'assets/images/promo/bgaming.svg'
import _imports_21 from 'assets/images/promo/nolimit.svg'
import _imports_22 from 'assets/images/promo/foxium.svg'
import _imports_23 from 'assets/images/promo/nyx.svg'
import _imports_24 from 'assets/images/promo/elk.svg'
import _imports_25 from 'assets/images/promo/isoftbet.svg'
import _imports_26 from 'assets/images/promo/jftw.svg'
import _imports_27 from 'assets/images/promo/egt.svg'
import _imports_28 from 'assets/images/promo/blueprint.svg'
import _imports_29 from 'assets/images/promo/onetouch.svg'
import _imports_30 from 'assets/images/promo/booming.svg'
import _imports_31 from 'assets/images/promo/habanero.svg'
import _imports_32 from 'assets/images/promo/pariplay.svg'
import _imports_33 from 'assets/images/promo/plankgaming.svg'
import _imports_34 from 'assets/images/promo/evolution.svg'
import _imports_35 from 'assets/images/promo/gameart.svg'
import _imports_36 from 'assets/images/promo/endorphina.svg'
import _imports_37 from 'assets/images/promo/ezugi.svg'
import _imports_38 from 'assets/images/promo/evoplay.svg'
import _imports_39 from 'assets/images/promo/pragmatic.svg'
import _imports_40 from 'assets/images/promo/igtech.svg'
import _imports_41 from 'assets/images/promo/playson.svg'
import _imports_42 from 'assets/images/promo/fortunefactory.svg'
import _imports_43 from 'assets/images/promo/mrslotty.svg'
import _imports_44 from 'assets/images/promo/pushgaming.svg'
import _imports_45 from 'assets/images/promo/platipus.svg'
import _imports_46 from 'assets/images/promo/Merkur_White.svg'
import _imports_47 from 'assets/images/promo/netent.svg'
import _imports_48 from 'assets/images/promo/tripleedgestudios.svg'
import _imports_49 from 'assets/images/promo/lucky.svg'
import _imports_50 from 'assets/images/promo/mascot.svg'
import _imports_51 from 'assets/images/promo/neonvalley.svg'
import _imports_52 from 'assets/images/promo/relax_gaming.svg'
import _imports_53 from 'assets/images/promo/redtiger.svg'
import _imports_54 from 'assets/images/promo/playngo.svg'
import _imports_55 from 'assets/images/promo/genesisgaming.svg'
import _imports_56 from 'assets/images/promo/sigmagaming.svg'
import _imports_57 from 'assets/images/promo/stormcraft.svg'
import _imports_58 from 'assets/images/promo/thunderkick.svg'
import _imports_59 from 'assets/images/promo/sthlmgaming.svg'
import _imports_60 from 'assets/images/promo/spinomenal.svg'
import _imports_61 from 'assets/images/promo/gamevy.svg'
import _imports_62 from 'assets/images/promo/realistic.svg'
import _imports_63 from 'assets/images/promo/slindshot.svg'
import _imports_64 from 'assets/images/promo/quickspin.svg'
import _imports_65 from 'assets/images/promo/booongo.svg'
import _imports_66 from 'assets/images/promo/rabcat.svg'
import _imports_67 from 'assets/images/promo/truelab_white.svg'
import _imports_68 from 'assets/images/promo/Wazdan.svg'
import _imports_69 from 'assets/images/promo/nucleus.svg'
import _imports_70 from 'assets/images/promo/visa.svg'
import _imports_71 from 'assets/images/promo/Mastercard_White.svg'
import _imports_72 from 'assets/images/promo/maestro.svg'
import _imports_73 from 'assets/images/promo/yandex.svg'
import _imports_74 from 'assets/images/promo/skrill.svg'
import _imports_75 from 'assets/images/promo/ecopayz.svg'
import _imports_76 from 'assets/images/promo/idebit.svg'
import _imports_77 from 'assets/images/promo/neosurf.svg'
import _imports_78 from 'assets/images/promo/paysafecard.svg'
import _imports_79 from 'assets/images/promo/rapid-transfer.svg'
import _imports_80 from 'assets/images/promo/alfaclick.svg'
import _imports_81 from 'assets/images/promo/neteller.svg'
import _imports_82 from 'assets/images/promo/instadebit.svg'
import _imports_83 from 'assets/images/promo/interac.svg'
import _imports_84 from 'assets/images/promo/russiancards.svg'
import _imports_85 from 'assets/images/promo/CoinsPaid_white.svg'
import _imports_86 from 'assets/images/promo/etransfer-white.svg'
import _imports_87 from 'assets/images/promo/copyright.png'


const _hoisted_1 = ["data-theme"]
const _hoisted_2 = {
  key: 0,
  autoplay: "",
  playsinline: "",
  loop: "",
  muted: "",
  preload: "auto",
  class: "modern-video-background"
}
const _hoisted_3 = ["src", "type"]
const _hoisted_4 = { class: "modern-head" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "modern-label-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-label-icon__img",
    src: _imports_0,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-label-icon__img",
    src: _imports_1,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-label-icon__img",
    src: _imports_2,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-label-icon__img",
    src: _imports_3,
    alt: "img"
  })
], -1)
const _hoisted_7 = { class: "modern-steper" }
const _hoisted_8 = { class: "modern-steper__block" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "modern-steper__img-block" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-steper__img",
    src: _imports_4,
    alt: "img"
  })
], -1)
const _hoisted_10 = { class: "modern-steper__label" }
const _hoisted_11 = { class: "modern-steper__block" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "modern-steper__img-block" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-steper__img",
    src: _imports_5,
    alt: "img"
  })
], -1)
const _hoisted_13 = { class: "modern-steper__label" }
const _hoisted_14 = { class: "modern-steper__block" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "modern-steper__img-block" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-steper__img",
    src: _imports_6,
    alt: "img"
  })
], -1)
const _hoisted_16 = { class: "modern-steper__label" }
const _hoisted_17 = { class: "modern-supplied" }
const _hoisted_18 = { class: "modern-supplied__title" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "modern-supplied__img-block" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_7,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_8,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_9,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_10,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_11,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_12,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_13,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_14,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_15,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_16,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_17,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_18,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_19,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_20,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_21,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_22,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_23,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_24,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_25,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_26,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_27,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_28,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_29,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_30,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_31,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_32,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_33,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_34,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_35,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_36,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_37,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_38,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_39,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_40,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_41,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_42,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_43,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_44,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_45,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_46,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_47,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_48,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_49,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_50,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_51,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_52,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_53,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_50,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_54,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_55,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_56,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_57,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_58,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_59,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_60,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_61,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_62,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_63,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_64,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_65,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_66,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_67,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_68,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_69,
    alt: "img"
  })
], -1)
const _hoisted_20 = { class: "modern-supplied modern-supplied__bottom" }
const _hoisted_21 = { class: "modern-supplied__title" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_70,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_71,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_72,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_73,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_74,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_75,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_76,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_77,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_78,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_79,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_80,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_81,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_82,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_83,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_84,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_85,
    alt: "img"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "modern-supplied__img",
    src: _imports_86,
    alt: "img"
  })
], -1)
const _hoisted_23 = { class: "modern-footer" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("img", {
  class: "modern-footer__img",
  src: _imports_87,
  alt: "copyright"
}, null, -1)
const _hoisted_25 = { class: "modern-footer__copyright" }

import { computed, ref, toRefs } from 'vue';
import { useCommonPromo } from '@/composables/useCommonPromo';
import Markdown from '@/components/markdown.vue';
import PromoPageRegForm from '@/components/promoPageRegForm.vue';
import { PromoPageInterface } from '~/types/promoPage.interface';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  props: {
    pageData: null
  },
  setup(__props: any) {

const props = __props as {
  pageData: PromoPageInterface;
}



const selectedCurrency = ref('');

const onChangeCurrency = (newCurrency: string) => {
  selectedCurrency.value = newCurrency;
};

const {
  dataPlatformAttr,
  theme,
  lang,
  targetHost,
  currency,
  videoBanner,
  promoLoader,
  logoImg,
  secondTitle,
  bannerCssVariables,
  onlyCrypto,
  renderTimeout,
} = useCommonPromo(props, selectedCurrency);

const {
  copyright_text: copyrightText,
  first_step: firstStep,
  first_step_label: firstStepLabel,
  first_title: firstTitle,
  footer_payment_methods: footerPaymentMethods,
  footer_supplied_by: footerSuppliedBy,
  footer_text: footerText,
  form_button_text: formBtnText,
  form_text: formText,
  form_title: formTitle,
  second_step: secondStep,
  second_step_label: secondStepLabel,
  third_step: thirdStep,
  third_step_label: thirdStepLabel,
  third_title: thirdTitle,
} = toRefs(props.pageData.params[0]);

const store = useStore();

const userCountry = computed((): string => store.getters['country/country']);

const preselectedCurrency = computed(() => {
  if (Array.isArray(props.pageData.params[0]?.second_title_multi)) {
    const titleForCountry = props.pageData.params[0].second_title_multi.find(
      (c) => c.country === userCountry.value
    );
    if (titleForCountry) {
      return titleForCountry.currency;
    }
    return currency.value;
  } else {
    return currency.value;
  }
})

return (_ctx: any,_cache: any) => {
  return (__props.pageData)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "modern-container",
        "data-theme": _unref(theme)
      }, [
        _createElementVNode("div", _mergeProps({ class: "modern-wrapper" }, _unref(dataPlatformAttr), { style: _unref(bannerCssVariables) }), [
          (_unref(videoBanner) && !_unref(renderTimeout))
            ? (_openBlock(), _createElementBlock("video", _hoisted_2, [
                _createElementVNode("source", {
                  src: _unref(videoBanner).url,
                  type: _unref(videoBanner).mime
                }, null, 8, _hoisted_3)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            (_unref(logoImg))
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "modern-head__img",
                  src: _unref(logoImg).url,
                  alt: "7bit-logo"
                }, null, 8, _hoisted_5))
              : _createCommentVNode("", true),
            _createVNode(Markdown, {
              "auto-link-parse": false,
              text: _unref(firstTitle),
              class: "title"
            }, null, 8, ["text"]),
            _createVNode(Markdown, {
              "auto-link-parse": false,
              text: _unref(secondTitle),
              class: "modern-head__title"
            }, null, 8, ["text"]),
            _createVNode(Markdown, {
              "auto-link-parse": false,
              text: _unref(thirdTitle),
              class: "modern-head__text"
            }, null, 8, ["text"])
          ]),
          _createVNode(PromoPageRegForm, {
            class: "modern-form",
            lang: _unref(lang),
            "form-title": _unref(formTitle),
            "form-btn-text": _unref(formBtnText),
            "form-text": _unref(formText),
            "promo-loader": _unref(promoLoader),
            "crypto-only": _unref(onlyCrypto),
            "preselected-currency": _unref(preselectedCurrency),
            "target-host": _unref(targetHost),
            onChangeCurrency: onChangeCurrency
          }, null, 8, ["lang", "form-title", "form-btn-text", "form-text", "promo-loader", "crypto-only", "preselected-currency", "target-host"]),
          _hoisted_6
        ], 16),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(Markdown, {
              "auto-link-parse": false,
              text: _unref(firstStep),
              class: "modern-steper__center"
            }, null, 8, ["text"]),
            _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(firstStepLabel)), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(Markdown, {
              "auto-link-parse": false,
              text: _unref(secondStep),
              class: "modern-steper__center"
            }, null, 8, ["text"]),
            _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(secondStepLabel)), 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createVNode(Markdown, {
              "auto-link-parse": false,
              text: _unref(thirdStep),
              class: "modern-steper__center"
            }, null, 8, ["text"]),
            _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(thirdStepLabel)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("h2", _hoisted_18, _toDisplayString(_unref(footerSuppliedBy)), 1),
          _hoisted_19
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("h2", _hoisted_21, _toDisplayString(_unref(footerPaymentMethods)), 1),
          _hoisted_22
        ]),
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          _createElementVNode("div", _hoisted_25, [
            _createVNode(Markdown, {
              "auto-link-parse": false,
              text: _unref(footerText)
            }, null, 8, ["text"]),
            _createVNode(Markdown, {
              "auto-link-parse": false,
              text: _unref(copyrightText),
              class: "modern-footer__copyright"
            }, null, 8, ["text"])
          ])
        ])
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})